import { Box, ModBox } from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/native'
import React, { FC, useCallback, useState } from 'react'
import { getYesterday } from '../../utils'
import { actionMenuStrings } from '../ActionMenu/ActionsMenu'
import { DateSelector } from '../DateSelection'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'
import { styles } from './styles'

const stats = [
  { id: '0', value: 'Today' },
  { id: '1', value: 'Last 7 days' },
  { id: '2', value: 'Last 30 days' },
  { id: '3', value: 'Last 90 days' },
  { id: '4', value: 'Custom Range/Date', iconId: 'CALENDAR' },
]

const reconDateRange = [
  { id: '0', value: 'Today' },
  { id: '7', value: 'Yesterday' },
  { id: '6', value: 'Last 2 days' },
  { id: '5', value: 'Last 3 days' },
  { id: '4', value: 'Custom Range/Date', iconId: 'CALENDAR' },
]

const payoutCmsUpdateDateRange = [
  { id: '0', value: 'Today' },
  { id: '7', value: 'Yesterday' },
  { id: '1', value: 'Last 7 days' },
  { id: '4', value: 'Custom Range/Date', iconId: 'CALENDAR' },
]

interface DateTabsProps {
  onDateSelector: (fromDate: Date, toDate: Date) => void
  disabled?: boolean
  maxRange?: number
  sendError?: any
  selectedDateInfo: any
  updateSelectedDate: any
  type: string
  defaultMinDate?:Date
}

const DateTabs: FC<DateTabsProps> = (props) => {
  const {
    onDateSelector,
    disabled,
    maxRange,
    sendError,
    updateSelectedDate,
    selectedDateInfo,
    defaultMinDate,
    type = 'default',
  } = props
  const [tabbarData, setTabbarData] = useState<[any]>(
    type === 'postRecon'
      ? reconDateRange
      : type === 'updatepayoutcms' || type === 'riskconfig'
        ? payoutCmsUpdateDateRange
        : stats,
  )


  const [calenderPosition, setCalenderPosition] = useState({
    left: 0,
    top: 0,
    visible: false
  })

  const [layoutEvent, setLayoutEvent] = React.useState<any>({})

  const getDateValue = (value: number): Date => {
    const today = new Date(Date.now())
    return new Date(today.setDate(today.getDate() - value))
  }

  const getSelectedDate = useCallback((type: number): Date => {
    const todayMidnight = new Date(new Date().setHours(0, 0, 0, 0))
    const getSelectedValue: any = {
      0: todayMidnight,
      1: getDateValue(7),
      2: getDateValue(30),
      3: getDateValue(90),
      5: getDateValue(3),
      6: getDateValue(2),
      7: getYesterday('START'),
    }
    return getSelectedValue[type]
  }, [])

  const onDateSelected = (dateObj: any): void => {
    updateSelectedDate({
      dateLabel: actionMenuStrings.customDate,
      fromDate: dateObj.fromDate,
      toDate: dateObj.toDate,
      // position: { ...dateObj.position, visible: false },
    })
    onDateSelector(dateObj.fromDate, dateObj.toDate)
  }



  const getRowId = (value: string) => {
    return value === 'Today'
      ? 0
      : value === 'Last 7 days'
        ? 1
        : value === 'Last 30 days'
          ? 2
          : value === 'Last 90 days'
            ? 3
            : value === 'Last 3 days'
              ? 5
              : value === 'Last 2 days'
                ? 6
                : value === 'Yesterday'
                  ? 7
                  : 4
  }

  const onDateRangeSelected = (value: string | number[], pos: any): void => {
    const dateStr = value.toString()
    const today = new Date(Date.now())
    const currentDay =
      dateStr === actionMenuStrings.customDate
        ? selectedDateInfo.toDate
        : value === 'Yesterday'
          ? getYesterday('END')
          : today
    const finishDay =
      dateStr === actionMenuStrings.customDate
        ? selectedDateInfo?.fromDate
        : getSelectedDate(getRowId(value?.toString()))
    updateSelectedDate({
      dateLabel: dateStr,
      fromDate: finishDay,
      toDate: currentDay,

    })
   if(dateStr===actionMenuStrings.customDate){
    layoutEvent?.target?.measure((...args: any) => {
      console.log("position args",args)
      setCalenderPosition({top: args[5]  +args[3]+10, left: args[4] , visible: true })
    })
   }
   
    if (dateStr !== actionMenuStrings.customDate && onDateSelector) {
      onDateSelector(finishDay, currentDay)
    }
  }

  const getTodayDate = () => {
    const date = new Date()
    return date
  }

  const onLayout= useCallback(({nativeEvent}:any)=>{
     console.log("nativeEvent",nativeEvent)
     setLayoutEvent(nativeEvent)
  },[])

  return (
    <Box>
      <ModBox show={true} {...styles().mobileSelectionFix} >
        <Box onLayout={onLayout}  >
        <DropdownOptimised
          placeHolder={selectedDateInfo.dateLabel}
          iconType="CALENDAR"
          onChange={onDateRangeSelected}
          data={tabbarData}
          type={DropdownTypes.DEFAULT_WITH_IMAGE}
          testID={'calendar'}
        />
        </Box>
        <DateSelector
          path={''}
          value={{
            fromDate: selectedDateInfo?.fromDate,
            toDate: selectedDateInfo?.toDate,
            position: { ...calenderPosition },
          }}
          isFocused={useIsFocused()}
          onDateSelected={onDateSelected}
          setNewDate={(dateObj: any) => {
            updateSelectedDate({
              dateLabel: actionMenuStrings.customDate,
              fromDate: dateObj.fromDate,
              toDate: dateObj.toDate,
            })
            setCalenderPosition(dateObj.position)
          }
          }
          defaultMaxDate={getTodayDate()}
          defaultMinDate={defaultMinDate}
          maxDuration={maxRange}
          scrollToCurrentDate={false}
          sendError={(err: string) => console.log('DateSelector error: ', err)}
        />
      </ModBox>
    </Box>
  )
}

export { DateTabs }
